var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMikee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 32,
    fill: "#1CB0F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 33.5,
    stroke: "#1CB0F6",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_71732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9993 39.4389C36.5709 39.4389 38.0782 38.8146 39.1896 37.7033C40.3009 36.592 40.9252 35.0847 40.9252 33.513V26.1056C40.9252 24.534 40.3009 23.0267 39.1896 21.9154C38.0782 20.804 36.5709 20.1797 34.9993 20.1797C33.4276 20.1797 31.9204 20.804 30.809 21.9154C29.6977 23.0267 29.0734 24.534 29.0734 26.1056V33.513C29.0734 35.0847 29.6977 36.592 30.809 37.7033C31.9204 38.8146 33.4276 39.4389 34.9993 39.4389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.37 33.5127C45.37 33.1198 45.2139 32.743 44.9361 32.4652C44.6583 32.1873 44.2814 32.0312 43.8885 32.0312C43.4956 32.0312 43.1188 32.1873 42.841 32.4652C42.5631 32.743 42.407 33.1198 42.407 33.5127C42.407 35.4773 41.6266 37.3614 40.2375 38.7506C38.8483 40.1397 36.9642 40.9201 34.9996 40.9201C33.0351 40.9201 31.151 40.1397 29.7618 38.7506C28.3727 37.3614 27.5922 35.4773 27.5922 33.5127C27.5922 33.1198 27.4362 32.743 27.1583 32.4652C26.8805 32.1873 26.5037 32.0312 26.1108 32.0312C25.7178 32.0312 25.341 32.1873 25.0632 32.4652C24.7854 32.743 24.6293 33.1198 24.6293 33.5127C24.6322 36.0044 25.5321 38.4116 27.1644 40.2942C28.7966 42.1767 31.0521 43.4086 33.5182 43.7646V46.8461H30.3922C30.0425 46.8461 29.7072 46.985 29.4599 47.2322C29.2126 47.4795 29.0737 47.8149 29.0737 48.1646V48.4905C29.0737 48.8402 29.2126 49.1756 29.4599 49.4228C29.7072 49.6701 30.0425 49.809 30.3922 49.809H39.607C39.9567 49.809 40.2921 49.6701 40.5394 49.4228C40.7867 49.1756 40.9256 48.8402 40.9256 48.4905V48.1646C40.9256 47.8149 40.7867 47.4795 40.5394 47.2322C40.2921 46.985 39.9567 46.8461 39.607 46.8461H36.4811V43.7646C38.9472 43.4086 41.2027 42.1767 42.8349 40.2942C44.4672 38.4116 45.3671 36.0044 45.37 33.5127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_71732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5555,
    height: 35.5555,
    fill: "white",
    transform: "translate(17.2217 17.2188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikee);
export default __webpack_public_path__ + "static/media/mikee.33605a9b58d89e9220f3794a8aecca46.svg";
export { ForwardRef as ReactComponent };